import $ from "jquery";
import { debounce } from "../utils/functions";

let reportListEl = $(".report-list");

$(function () {
  if (reportListEl.length > 0) {
    reportListEl.each(function () {
      reportList($(this));
    });
  }
});

const reportList = (listEl) => {
  const filter = {
    page: 1,
    limit: listEl.data("limit"),
    lang: listEl.data("lang"),
    area: -1,
    finding: -1,
    period: -1,
  };

  bindReportFilter(listEl, filter);
};

const reRenderReport = async (element, filter) => {
  const data = await getReport(filter);
  element.find(".report-list-ajax").html(data.html);
};

const bindReportFilter = (element, filter) => {
  element.on("click", ".pagination__item", function () {
    filter.page = $(this).data("page");
    reRenderReport(element, filter);
  });

  element.on("change", "select[name='area']", function () {
    filter.page = 1;
    filter.area = $(this).val();
    reRenderReport(element, filter);
  });

  element.on(
    "input",
    "input[name='search']",
    debounce(function () {
      filter.search = $(this).val();
      reRenderReport(element, filter);
    })
  );

  element.on("change", "select[name='area']", function () {
    filter.page = 1;
    filter.area = $(this).val();
    reRenderReport(element, filter);
  });

  element.on("change", "select[name='finding[]']", function () {
    filter.page = 1;
    filter.finding = $(this).val();
    reRenderReport(element, filter);
  });

  element.on("change", "select[name='period']", function () {
    filter.page = 1;
    filter.period = $(this).val();
    reRenderReport(element, filter);
  });
};

const getReport = async (filter) => {
  try {
    const response = await fetch(`/wp-json/kvop/v1/reports/html`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(filter),
    });
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};
